import './page.css';
import projects from '../data/animationprojects.json'

function AnimationProject(project){
	const title = project.title;
	const summary = project.summary;
	const link = project.link;
	const photo = project.photo;

	function HoverButton(e){
		e.target.style.background ="rgb(255, 169, 255)"
		e.target.style.color = "black"
		e.target.style.cursor = "pointer";
	}

	function LeaveButton(e){
		e.target.style.background = '#3f3f3f'
		e.target.style.color = "white"
	}

	return(
		<div className='card card-smaller'>
			<a href={`./images/${photo}`} target="_blank" title="Make image larger in new tab">
				<img src = {`./images/${photo}`} className='img'></img>
			</a>
			
			<div className='card-info card-column'>
				<div className='card-title-link card-row'>
					<p>{title}</p>
					{link ? 
					<a href={link} target='_blank'>
						<button onMouseLeave = {LeaveButton} onMouseOver = {HoverButton} className='link'>Direct Link</button>
					</a>
					: null
					}
				</div>
				<p>{summary}</p>
			</div>

		</div>
	)
}

export default function AnimationProjects () {

	return(
		<>
		<h1 className='headline pads'>Animation Projects - {projects.length} Items</h1>
		<div className='cards card-column pads'>
			{projects.map(project =>(
				<AnimationProject {...project}/>
			))
			}
		</div>
		</>
	)
}